<div [attr.class]="'spinner-border spinner-border-'+size" role="status">
    <span class="visually-hidden">Loading...</span>
</div>